import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BsDaterangepickerConfig} from 'ngx-bootstrap/datepicker';
import * as moment from 'moment';
import {NGXLogger} from 'ngx-logger';

@Component({
  selector: 'app-mat-date-range-selection',
  templateUrl: './mat-date-range-selection.component.html',
  styleUrls: ['./mat-date-range-selection.component.css']
})
export class MatDateRangeSelectionComponent implements OnInit {
  @Output() newPlacement = new EventEmitter<string>();
  bsConfig: Partial<BsDaterangepickerConfig> = Object.assign({}, {
    containerClass: 'theme-dark-blue', placement: this.newPlacement, displayOneMonthRange: true, displayMonths: 1});

  now = moment();
  startOfDay = this.now.startOf('day');
  endOfDay = this.now.endOf('day');

  startOfDayAsDate: string = moment(this.startOfDay.format()).toISOString();
  endOfDayAsDate: string = moment(this.endOfDay.format()).toISOString();

  selectedDate = [
    this.startOfDayAsDate,
    this.endOfDayAsDate
  ];
  // @Input() placement = 'bottom';
  @Output() newDate = new EventEmitter<string[]>();
  @Input() set _preSetDate(preSetDate) {
    if (typeof preSetDate === 'string') {
      preSetDate = preSetDate.split(',');
    }
    this.logger.log(preSetDate);
    const startDate: string = moment(preSetDate[0]).startOf('day').toISOString();
    const endDate: string = moment(preSetDate[1]).endOf('day').toISOString();
    this.selectedDate = [startDate, endDate];
    this.logger.log(this.selectedDate);
  }

  constructor(
    private logger: NGXLogger
  ) {
  }

  ngOnInit() {
    this.setPlacement(this.newPlacement);
  }

  setDate(date) {
    // this.logger.log( 'From date-range-selection setDate: ' + date[0].toISOString());
    // this.logger.log( 'From date-range-selection setDate: ' + date[1].toISOString());

    const startOfFirstDay: string = moment(date[0]).startOf('day').toISOString();
    const endOfLastDay: string = moment(date[1]).endOf('day').toISOString();

    this.logger.log('From date-range-selection setDate: ' + startOfFirstDay);
    this.logger.log('From date-range-selection setDate: ' + endOfLastDay);

    this.selectedDate = [startOfFirstDay, endOfLastDay];
    this.newDate.emit(
      [
        startOfFirstDay,
        endOfLastDay
      ]
    );
  }

  setPlacement(placement) {
    this.newPlacement.emit(
      placement
    );
    this.logger.log('placement');
    this.logger.log(placement);
  }

}
